import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../../../../../../redux/store';
import { sessionViewSelectors } from '../../../../../../../../redux/views/session-view/session/slice';
import { useSessionUserContext } from '../../../../../../../../hooks/use-session-user-context';
import { ConnectedDCloudControl } from './dCloudContainer';
import { ConnectedPublicControl } from './publicContainer';

export function ControlContainer({
  nodeUid,
}: ControlContainerProps): ReactElement {
  const { accessKey, sessionUid, versionUid } = useSessionUserContext();
  if (accessKey) {
    return (
      <ConnectedPublicControl
        accessKey={accessKey}
        nodeUid={nodeUid}
        sessionUid={sessionUid}
        versionUid={versionUid}
      />
    );
  }

  return (
    <ConnectedDCloudControl
      nodeUid={nodeUid}
      sessionUid={sessionUid}
      versionUid={versionUid}
    />
  );
}

const mapStateToProps = (state: RootState) => ({
  nodeUid: sessionViewSelectors.getLeftPanelDeviceUid(state),
});

export type ControlContainerProps = ReturnType<typeof mapStateToProps>;

export const ConnectedHwControl = connect(mapStateToProps)(ControlContainer);
